var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.277 11.995c2.5119 0 4.5481-2.0363 4.5481-4.5481 0-2.5119-2.0362-4.5481-4.5481-4.5481s-4.5481 2.0363-4.5481 4.5481c0 2.5119 2.0363 4.5481 4.5481 4.5481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.554 18.362c0 1.5009-1.228 2.7289-2.7288 2.7289h-9.0963c-1.5008 0-2.7289-1.228-2.7289-2.7289 0-2.5102 2.0376-4.5481 4.5481-4.5481h5.4577c2.5106 0 4.5481 2.0379 4.5481 4.5481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.2448 21.101h9.0878c0.3452 0 0.62536-0.28016 0.62536-0.62536v-2.9184c0-1.6557-1.0215-3.0777-2.4673-3.6684l5e-3 -0.0096c-0.45026-0.17762-0.93632-0.28268-1.4475-0.28268h-7.1382c-0.51113 0-0.99725 0.10506-1.4475 0.28272l0.00505 0.0096c-1.4459 0.59064-2.4674 2.0126-2.4674 3.6683v2.9184c0 0.3452 0.28016 0.62536 0.62536 0.62536zm13.086-6.2732c-1.0448-0.79268-3.8695-1.0161-3.8695-1.0161s1.324 0.94155 1.7588 3.1268v4.143l3.1543 0.01957c0.3452-3e-6 0.62536-0.28017 0.62536-0.62537v-2.9184c0-1.0276-0.74032-2.0247-1.669-2.7295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.283 7.4467c0 2.5103-2.0375 4.5481-4.5481 4.5481-0.30907 0-0.61847-0.02752-0.90964-0.09994 1.128-1.1464 1.8193-2.72 1.8193-4.4482s-0.69129-3.3018-1.8193-4.4482c0.29117-0.072387 0.60057-0.099936 0.90964-0.099936 2.5106 3.34e-5 4.5481 2.0378 4.5481 4.5481z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.0dc6d197810973f72a5c865d8dadb1a8.svg";
export { ForwardRef as ReactComponent };